import List from '@mui/material/List';
import { Collapse, Typography } from '@mui/material';
import { useContext, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import ItemList from './components/ItemList';
import { GlobalUtilContext } from '../../contexts';
import { Drawer, DrawerHeader } from './styled';

import { ArrowSVG } from '../svgs/ArrowSVG';
import NSLogo from '../../../assets/ns_logo.svg';
import './collapse.css';
import { LogOut } from './components/Logout';
import { logout } from '../../../services/core/auth';

export const menuOptions = [
  {
    label: 'drawer.aggregated_stats',
    association_type: 'globe'
  },
  {
    label: 'drawer.individual_stats',
    association_type: 'person'
  }
];

function DynamicDrawer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    selectedService,
    handleSelectedService,
    handleSelectedPartner,
    selectedPartnerHistory,
    navItems,
    setIsLoading,
    setIsLoggedIn,
    setSelectedDatasourceTab,
    selectedDatasourceTab,
    resetDrawer
  } = useContext(GlobalUtilContext);

  const handleLogout = useCallback(() => {
    const doLogout = async () => {
      const serviceName = localStorage.getItem('service');
      setIsLoading(true);
      await logout();

      setIsLoggedIn(false);
      setIsLoading(false);

      navigate(`/${serviceName}`);
    };

    doLogout();
  }, [setIsLoading, setIsLoggedIn]);

  const handleBack = useCallback(async () => {
    resetDrawer();
  }, [resetDrawer, selectedService]);

  const handleTabs = useCallback(
    (selectedTab) => {
      if (selectedTab.label === menuOptions[0].label) {
        handleSelectedPartner(null);
        setSelectedDatasourceTab(selectedTab);
      } else {
        setSelectedDatasourceTab(selectedTab);
      }
    },
    [setSelectedDatasourceTab, handleSelectedPartner]
  );

  return (
    <Drawer open secondaryOpen={selectedService} sx={{ position: 'relative' }} variant="permanent">
      {/* Drawer when no service is selected */}
      <Collapse
        in={!selectedService}
        orientation="horizontal"
        sx={{ display: 'flex', justifyContent: 'center', position: 'absolute', zIndex: 10 }}
      >
        <DrawerHeader>
          <img alt="content" src={NSLogo} style={{ width: 144, height: 35 }} />
        </DrawerHeader>
        <Typography
          sx={{
            fontFamily: 'Mulish',
            fontSize: '10px',
            color: '#FFFFFF',
            opacity: '50%',
            textTransform: 'uppercase',
            px: 2,
            mt: 2
          }}
        >
          {t('drawer.title')}
        </Typography>
        <List>
          <ItemList items={navItems} set={handleSelectedService} />
        </List>
      </Collapse>

      {/* Drawer when a service is selected */}
      <Collapse
        in={selectedService}
        orientation="horizontal"
        sx={{ display: 'flex', justifyContent: 'center', position: 'absolute', zIndex: 11 }}
      >
        <DrawerHeader onClick={handleBack}>
          <ArrowSVG />
        </DrawerHeader>
        <List>
          <Typography
            sx={{
              fontFamily: 'Mulish',
              fontSize: '10px',
              color: '#FFFFFF',
              opacity: '50%',
              textTransform: 'uppercase',
              px: 2,
              mt: 1
            }}
          >
            {t('drawer.secondary-title')}
          </Typography>
          <ItemList items={menuOptions} set={handleTabs} selectedItem={selectedDatasourceTab} />

          <Typography
            sx={{
              fontFamily: 'Mulish',
              fontSize: '10px',
              color: '#FFFFFF',
              opacity: '50%',
              textTransform: 'uppercase',
              px: 2,
              mt: 2
            }}
          >
            {t('drawer.history')}
          </Typography>
          <ItemList items={selectedPartnerHistory} set={handleSelectedPartner} />
        </List>
      </Collapse>
      <LogOut
        username={localStorage?.getItem('service')}
        handleLogout={handleLogout}
        sx={{ path: { fillColor: 'white' } }}
      />
    </Drawer>
  );
}

export default DynamicDrawer;
